module.exports = __webpack_public_path__ + "img/1920x793px.56caf881.png";